// Legacy stub. The legacy contract dataset lived here; only
// CURRENT_USER_ID is still referenced from Messages.tsx for offline
// chat fallback. Stub it as an empty string so callers can detect the
// "no profile loaded" case the way they always have.
//
// TODO: replace this in Messages.tsx with the auth profile path and
// delete this file.

export const CURRENT_USER_ID = '';

// Other legacy bits referenced from data/mockThreads.ts. Stub shape
// matches what callers read; no real users — empty record so any
// access is undefined and the chat fallback path skips the row.
export const mockUsers: Record<string, {
  user_id: string;
  displayName: string;
  nickname: string;
  avatar?: string;
}> = {};
